<template>
  <div>
    <el-table :data="datas" border>
     
      <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
      <!-- <el-table-column  label="confIntroduction">
        <template slot-scope="scope">
          <span>{{ scope.row.confIntroduction ?scope.row.confIntroduction:'暂无' }}</span>
          
        </template>
      </el-table-column> -->
      <el-table-column prop="confKey" label="confKey" width="320"></el-table-column>
      <el-table-column prop="confValue" label="confValue" show-overflow-tooltip width="840"></el-table-column>
      <el-table-column prop="confIntroduction" label="confIntroduction" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.confIntroduction?scope.row.confIntroduction:'--'}}</span>
        </template>
      </el-table-column>
      <el-table-column  label="操作" width="120">
        <template slot-scope="scope">
          <el-button 
          size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
            ></el-button>
          <el-button 
          size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="handleDel(scope.row)"
            circle></el-button>
        </template>
      </el-table-column>
    </el-table>

          <el-dialog
        title="编辑配置"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form :model="detail" ref="form" :rules="rules" label-width="120px">
      
      <el-form-item label="confKey" prop="confKey">
        <el-input
          :controls="false"
          v-model="detail.confKey"
          disabled
        ></el-input>
      </el-form-item>
    
      <el-form-item label="confValue" prop="confValue">
        <el-input
        type="textarea"
          v-model="detail.confValue"
          :controls="false"
          :min="0"
        ></el-input>
      </el-form-item>
      <el-form-item label="confIntroduction" prop="confIntroduction">
        <el-input
        type="textarea"
          v-model="detail.confIntroduction"
          :controls="false"
          :min="0"
        ></el-input>
      </el-form-item>
    </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"  @click="handleSave('form')">确 定</el-button>
        </span>
      </el-dialog>








    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'SiteconfList',
  data() {
    return {
      dialogVisible:false,
      detail:{},
      rules: {
        confValue: {
          required: true,
          message: "请填写confValue",
          trigger: "blur",
        },
        confKey: {
          required: true,
          message: "请填写confKey",
          trigger: "blur",
        },
       
      },
    }
  },
  computed: {
    ...mapState('Siteconf', ['totalCount', 'pagination','datas']),
    ...mapGetters('Siteconf', ['list'])
  },
  components: {
    Pagination
  },

  methods: {
    ...mapActions('Siteconf', ['remove','updateOne']),
    ...mapMutations('Siteconf', ['setDetail']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    handleUpdate(row){
      this.detail={...row}
      this.dialogVisible=true
    },
    handleSave(){
      this.$refs["form"].validate((valid)=>{
        if(valid){
          this.updateOne({...this.detail}).then(res=>{
              this.$emit('refresh', { page: 1 });
            this.dialogVisible=false
          })
        }
      })
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    handleDel(row) {
      this.$confirm('确认要删除么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.remove(row.confKey).then(() => {
          this.$message({
            message: '删除成功！',
            type: 'success'
          });
          this.$emit('refresh', { page: 1 });
        });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
